import { Box, Stack, styled } from '@mui/material';

export const InfoBox = styled(Stack)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const InfoContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 16px;
  gap: 8px;
`;
